import React from "react";

// After a deploy the old page files are gone: a tab opened before it fails to
// load the next page (ChunkLoadError) and shows a blank screen. Every lazy
// page goes through React.lazy, so it is wrapped here once: on such an error
// the tab reloads itself (at most once in 30 s) and gets the new version.
const KEY = "vb_chunk_reload_at";
const isChunkError = (err) =>
  err && (err.name === "ChunkLoadError" || /Loading (CSS )?chunk [\w-]+ failed/i.test(err.message || ""));

const reloadOnce = () => {
  let last = 0;
  try {
    last = Number(sessionStorage.getItem(KEY)) || 0;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch (e) {
    // storage off: still reload once per page load
  }
  if (Date.now() - last < 30000) return false;
  window.location.reload();
  return true;
};

const originalLazy = React.lazy;
React.lazy = (factory) =>
  originalLazy(() =>
    factory().catch((err) => {
      // the page reloads: keep the component pending meanwhile
      if (isChunkError(err) && reloadOnce()) return new Promise(() => {});
      throw err;
    })
  );
